import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PriceService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(form: any): any{
    return this.http.post(`${this.url}/price/create`, form);
  }

  update(id: string, form: any): any{
    return this.http.post(`${this.url}/price/update/${id}`, form);
  }

  delete(data: any): any{
    return this.http.post(`${this.url}/price/delete`, data);
  }

  getAllByOrganization(filter: any): any {
    return this.http.get(`${this.url}/prices/organization`, { params: filter });
  }
}
